import 'bulma/bulma.sass';
import './styles/mystyles.scss'

export class PostSet {
    private divElement: HTMLDivElement | null;
    private options: any;
    private baseurl: string;

    constructor(divId: string, options: any) {
        // 尝试获取 DOM 元素并赋值给成员变量
        const elem = document.getElementById(divId);
        this.divElement = elem as HTMLDivElement | null;
        this.options = options;

        this.divElement.style.position= 'relative';
    }

    public generate_init_panel(): void {
        const panelRoot = document.createElement('div');
        panelRoot.className = 'panelRoot';
    }

    public getDivElement(): HTMLDivElement | null {
        return this.divElement;
    }
    public getOptions(): any {
        return this.options;
    }
    public setOptions(options: any): void {
        this.options = options;
    }
    public setDivElement(divId: string): void {
        const elem = document.getElementById(divId);
        this.divElement = elem as HTMLDivElement | null;
    }
    public getBaseUrl(): string {
        return this.options.baseurl;
    }
    public setBaseUrl(baseurl: string): void {
        this.options.baseurl = baseurl;
    }

    public generate_const_baseurl(): void{
        this.generate_const_baseurl(this.options.baseUrl);
    }
    public generate_const_baseurl(baseUrl:string): void{

    }

    public generate_dynamic_baseurl(): void{
        this.generate_dynamic_baseurl(this.options.baseUrl);
    }
    public generate_dynamic_baseurl(baseUrl:string): void{

    }

}
